/* tjs <- index-debug.ts */

const g = globalThis;

if (g.__tjs?.configure) {
    g.__tjs.configure({ throwTypeErrors: true, logTypeErrors: true });
}
else {
    g.__tjs = {
        ...g.__tjs,
        getConfig: () => ({ throwTypeErrors: true, logTypeErrors: true }),
    };
}

export * from './index';